import React from "react";

export default function DashboardSkeleton() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="h-1 w-full bg-gradient-to-r from-indigo-500 via-sky-500 to-emerald-400" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 space-y-8 animate-pulse">
        {/* Header */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-3 w-full max-w-sm">
            <div className="h-3 w-24 bg-slate-800 rounded-full" />
            <div className="h-8 w-64 bg-slate-800 rounded-lg" />
            <div className="h-4 w-full bg-slate-800 rounded-md" />
          </div>
          <div className="flex items-center gap-3">
            <div className="h-10 w-24 bg-slate-800 rounded-full" />
            <div className="h-10 w-32 bg-slate-800 rounded-full" />
          </div>
        </div>

        {/* Filter Bar */}
        <div className="h-16 w-full rounded-2xl bg-slate-800/50" />

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-36 rounded-2xl border border-slate-800 bg-slate-900/60 p-5 flex flex-col justify-between">
              <div className="h-3 w-24 bg-slate-800 rounded-full" />
              <div className="space-y-2">
                <div className="h-10 w-20 bg-slate-800 rounded-lg" />
                <div className="h-3 w-32 bg-slate-800 rounded-full" />
              </div>
            </div>
          ))}
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          {[1, 2].map((i) => (
            <div key={i} className="h-96 rounded-2xl border border-slate-800 bg-slate-900/60 p-6 flex flex-col">
              <div className="h-3 w-20 bg-slate-800 rounded-full mb-2" />
              <div className="h-6 w-40 bg-slate-800 rounded-md mb-6" />
              <div className="flex-1 bg-slate-800/50 rounded-xl" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
